/**
 * A mark per widget type (ARCHITECTURE.md §103.2, §65).
 *
 * Inline SVG, drawn here rather than fetched: the CSP permits `img-src 'self'`
 * and no CDN, and these are geometry rather than anybody's brand — so unlike
 * `PlatformIcon`, which serves real provider marks from `public/platforms/`,
 * there is no asset to get wrong. No emoji: an emoji renders differently on
 * every operating system and is a font glyph rather than an icon.
 *
 * DECORATIVE. The widget's name always sits beside it, so announcing the icon
 * would make a screen reader say the same thing twice (§65).
 */

const PATHS: Record<string, string> = {
  // A running list — the activity feed.
  ACTIVITY_FEED: 'M4 6h16M4 12h16M4 18h10',
  // Speech, for chat.
  CHAT_OVERLAY: 'M21 12a8 8 0 0 1-8 8H7l-4 3V12a8 8 0 0 1 8-8h2a8 8 0 0 1 8 8Z',
  // A tag, for a single label.
  EVENT_LABELS: 'M3 7h11l7 5-7 5H3V7Zm14 3.5v3',
  // A rising bar, for a goal.
  GOAL: 'M4 20V10m5 10V4m5 16v-7m5 7V7',
};

export function WidgetTypeIcon({
  type,
  size = 20,
}: {
  type: string;
  size?: number;
}): React.JSX.Element {
  const path = PATHS[type] ?? (type.endsWith('GOAL') ? PATHS.GOAL : PATHS.ACTIVITY_FEED);

  return (
    <svg
      className="widget-type-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={path} />
    </svg>
  );
}
